export function WhyChooseUs() {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          <div className="hidden md:block lg:w-1/2">
             <div className="relative rounded-2xl overflow-hidden shadow-2xl">
               <img 
                 src="https://images.unsplash.com/photo-1763739527737-e3626d731072?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMG1lZXRpbmclMjBzdHJhdGVneSUyMGNvbnN1bHRpbmd8ZW58MXx8fHwxNzcxNTA5MzcyfDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral" 
                 alt="Strategic Planning"
                 className="w-full h-full object-cover" 
               />
               <div className="absolute inset-0 bg-[#FD5750]/10 mix-blend-multiply"></div>
             </div>
          </div>
          
          <div className="lg:w-1/2">
            <span className="text-[#FD5750] font-bold text-sm tracking-widest uppercase mb-2 block">Why Intelisine</span>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
              More Than Just a Vendor.<br/>
              <span className="text-[#FD5750]">We Are Your Growth Partner.</span>
            </h2>
            <p className="text-slate-600 text-lg mb-8 leading-relaxed">
              Unlike traditional IT shops that just execute tasks, we bring a consultant's mindset to every project. We challenge assumptions, optimize processes, and ensure that every digital dollar you spend contributes directly to your bottom line.
            </p>
            
            <div className="space-y-6">
               <div className="flex gap-4">
                 <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center text-[#FD5750] font-bold text-xl flex-shrink-0">1</div>
                 <div>
                   <h4 className="font-bold text-slate-900 text-lg">Business-First Approach</h4>
                   <p className="text-slate-600 text-sm mt-1">We align technology with your business KPIs, not the other way around.</p>
                 </div>
               </div>
               <div className="flex gap-4">
                 <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center text-[#FD5750] font-bold text-xl flex-shrink-0">2</div>
                 <div>
                   <h4 className="font-bold text-slate-900 text-lg">Premium Quality, Startup Agility</h4>
                   <p className="text-slate-600 text-sm mt-1">Get the code quality of an enterprise with the speed and flexibility of a startup.</p>
                 </div>
               </div>
               <div className="flex gap-4">
                 <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center text-[#FD5750] font-bold text-xl flex-shrink-0">3</div>
                 <div>
                   <h4 className="font-bold text-slate-900 text-lg">Long-Term Reliability</h4>
                   <p className="text-slate-600 text-sm mt-1">We don't disappear after launch. We are here to support your growth for years to come.</p>
                 </div>
               </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
